// Script for cart drawer - manages unique IDs for line items

// Set random generated id as product property to show every line item separated in cart
function setProductProperty() {
    const productForms = document.querySelectorAll('.product-form form');
    if(productForms.length === 0) return;

    productForms.forEach(form => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_randomId]';
        input.value = crypto.randomUUID();
        form.appendChild(input);
    })
};

subscribe(PUB_SUB_EVENTS.cartUpdate, setProductProperty);
subscribe(PUB_SUB_EVENTS.variantChange, setProductProperty);

document.addEventListener('DOMContentLoaded', () => {
    setProductProperty();
})